import axios from "../../common/cotAxios";
import {BackendList} from "./model/Program";

export default {


    // 指定のプログラムにビデオを追加
    AddVideoToProgram(userId: string, programId: string, videoId: string, videoType: number) {
        return axios.post("/api/addVideoToProgram",
            {userId: userId, programId: programId, videoId: videoId, videoType: videoType}
        )
            .then(({data}) => data);
    },

    //プログラム更新
    UpdateProgram(userId: string, updateListItems: BackendList[]) {
        const params = new FormData();
        params.append("userId", userId);
        if (updateListItems.length === 0) {
            // プログラム全件削除の場合
            params.append("file", new File([""], "empty"));
            params.append("program", new Blob([" "], {type: "application/json"}));
        } else {
            let sendPrograms = "";
            updateListItems.map((row) => {
                params.append("file", row.file === null || row.file === undefined ? new File([""], "empty") : row.file);

                if (sendPrograms !== "") {
                    sendPrograms = sendPrograms + "," + JSON.stringify({
                        id: row.id,
                        title: row.title,
                        description: row.description,
                        imageUrl: row.imageUrl,
                        videoIds: row.videoIds,
                        relatedVideoIds: row.relatedVideoIds
                    });
                }
                else{
                    sendPrograms = JSON.stringify({
                        id: row.id,
                        title: row.title,
                        description: row.description,
                        imageUrl: row.imageUrl,
                        videoIds: row.videoIds,
                        relatedVideoIds: row.relatedVideoIds
                    });
                }
                return null;
            });
            params.append("program", new Blob([sendPrograms], {type: "application/json"}));
        }

        return axios.post("/api/updateProgram", params,
            {
                headers: {"content-type": "multipart/form-data"}
            })
            .then(({data}) => data);
    }
};
